import React, {useState, useEffect} from "react";
import { ChoixPeriodeLayout } from "../shared/ChoixPeriodeLayout";

export const ChoixPeriodeAncv = () => {
const PRESTATION_NAME="ancv";
  return (
    <ChoixPeriodeLayout prestationName={PRESTATION_NAME}/>
  );

};
